module.exports = __webpack_public_path__ + "img/error-icon.8bf4e900.svg";